import { BadgeType } from '@shared/utils/evidence-management';
import { IconType } from '@shared/utils/icons';
import { MenuItem } from 'primeng/api';

export class ButtonGroupOptions implements MenuItem {
  public styleClass?: string;

  constructor(
    public label: string,
    public command: () => void,
    public icon: IconType,
    public link?: string,
    public badgeText?: string,
    public badgeType?: BadgeType,
    public condition: boolean = true,
    public description?: string
  ) {}
}
